import Gb from "../../assets/images/flags/gb.svg?react";

export default Gb;
